import type { TOC } from '@ember/component/template-only';
import {
  PrismBadge,
  PrismIcon,
  PrismIconBrand,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface GeneralTooltipsTooltipPropertyDetailsSignature {
  Args: {
    property: unknown;
  };
}

const GeneralTooltipsTooltipPropertyDetails = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div class="tooltip-single-property-details">
    <div class="flex flex-row justify-between">
      <span
        class="property-name text-400--bold mr-400"
        title={{@property.name}}
      >
        {{@property.name}}
      </span>
      <button
        class="button--unstyled"
        id="close-tooltip"
        slot="close-icon"
        type="button"
      >
        <PrismIcon @name="cross" />
      </button>
    </div>
    <div
      class="text-200--regular tooltip-single-property-detail__icons mt-400 mb-200 flex flex-row justify-between gap-200"
    >
      <div class="flex flex-row items-center">
        <div class="mr-200">
          <PrismBadge
            @iconName="star-filled"
            @label={{@property.reviewScore}}
          />
        </div>
        <div class="mr-100">
          <PrismIcon @name="meals-room-only" @size="small" />
        </div>
        <span class="mr-400">{{@property.beds}}</span>
        <span class="mr-100">
          <PrismIcon @name="amenities-shower" @size="small" />
        </span>
        <span class="mr-400">{{@property.bathrooms}}</span>
        <span class="mr-100">
          <PrismIcon @name="user-group" @size="small" />
        </span>
        <span>{{@property.capacity}}</span>
      </div>
      <div class="flex items-center gap-100">
        {{#each @property.sortedRedirects as |redirect|}}
          <a href={{redirect.urls}} rel="noopener noreferrer" target="_blank">
            <PrismIconBrand @name={{redirect.platform}} />
          </a>
        {{/each}}
      </div>
    </div>
    <div class="text-200--regular mb-200 flex flex-row justify-between">
      <div>{{t "short_term_rental.property_type"}}</div>
      <div>{{@property.propertyType}}</div>
    </div>
    <div class="text-200--regular mb-100 flex flex-row justify-between">
      <div>{{t "short_term_rental.room_category"}}</div>
      <div>{{@property.roomCategory}}</div>
    </div>
    <div class="text-200--bold flex flex-row justify-between pt-100 pb-200">
      <span>{{t "short_term_rental.amenities"}}</span>
      <div class="toggle-amenities-box flex flex-row">
        {{@property.formattedAmenities.length}}
        <span id="icon-toggle-amenities">
          <PrismIcon @name="chevron-down" @size="small" />
        </span>
      </div>
    </div>
    <div class="amenities-box-container text-200--regular flex flex-row">
      <div class="amenities-box pt-100 pb-200 pl-200">
        <ul class="amenities-list">
          {{#each @property.formattedAmenities as |amenity|}}
            <li class="pt-100">{{amenity}}</li>
          {{/each}}
        </ul>
      </div>
    </div>
    <div class="text-200--regular mb-200 flex flex-row justify-between">
      <div>{{t "short_term_rental.x_month_average_rate" count=3}}</div>
      <div>{{@property.formattedAverageRate}}</div>
    </div>
    <div class="text-200--regular mb-200 flex flex-row justify-between">
      <div class="flex items-center justify-start gap-100">
        {{t "short_term_rental.extra_fees_per_stay"}}
      </div>
      <div>{{@property.formattedAdditionalFees}}</div>
    </div>
    <div class="text-200--regular flex flex-row justify-between">
      <div>{{t "short_term_rental.next_x_month_otb" count=3}}</div>
      <div>{{@property.formattedOccupancy}}</div>
    </div>
  </div>
</template> satisfies TOC<GeneralTooltipsTooltipPropertyDetailsSignature>;

export default GeneralTooltipsTooltipPropertyDetails;
